import React from 'react';
import { TemplatePreviewTemplate } from 'themes/application/patient/pages';
import { observer } from 'mobx-react';
import { TemplatePreviewViewStore } from 'application/patient/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new TemplatePreviewViewStore(rootStore), 'templatePreviewViewStore')
@observer
class TemplatePreview extends React.Component {
    render() {
        return <TemplatePreviewTemplate {...this.props} />
    }
}

export default TemplatePreview;